<app-user-form
    mode="create"
    [isSubmitting]="submitting()"
    (formSubmit)="onSubmit($event)"
></app-user-form>
